// Packages
import React from "react";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import jobUtil from "../../modules/jobUtilities";
// Components
import {
    InputItem,
    Button,
    Toast,
    Icon,
    TextareaItem,
    DatePicker,
    List,
    Switch,
    Modal,
} from "antd-mobile";
// Styles
import "./JobNew.scss";

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

@inject("store")
@observer
class JobNew extends React.Component {
    @observable
    loading = false;

    @observable
    user = {};

    @observable
    job = {
        name: "",
        start_date: new Date(),
        end_date: new Date(),
        default_fee: "",
        description: "",
        pre_signup: false,
        max_registration: "0",
    };

    @action.bound
    handleChange = async (key, event) => {
        switch (key) {
            case "name":
                this.job.name = event;
                break;
            case "start_date":
                this.job.start_date = event;
                this.job.end_date = event;
                break;
            case "end_date":
                this.job.end_date = event;
                break;
            case "default_fee":
                this.job.default_fee = event;
                break;
            case "description":
                this.job.description = event;
                break;
            case "pre_signup":
                if (
                    event === true &&
                    (await this.isPreSignupAllowed()) === true
                ) {
                    this.job.pre_signup = event;
                } else {
                    this.job.pre_signup = false;
                }
                break;
            case "max_registration":    
                this.job.max_registration = event;
                break;
            default:
                console.log("Unknown form value change");
        }
    };

    isMobileDevice() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

    async isPreSignupAllowed() {
        if ((await this.isVerifiedAccount()) === false) {
            Modal.alert(
                "Stripe Account Not Found",
                "You must setup your Stripe account to turn on pre-registration. Do you want to do it now?",
                [
                    { text: "No", onPress: () => console.log("Closing Modal") },
                    {
                        text: "Yes",
                        onPress: () =>
                            this.props.history.push("/stripe-settings"),
                    },
                ]
            );
            return false;
        }

        if (
            this.user.phone === undefined ||
            this.user.phone === null ||
            this.user.phone === ""
        ) {
            Modal.alert(
                "Missing Phone Number",
                "You must have a valid phone number associated to your account to start a pre-signup. Do you want to visit your account settings to set up a phone number?",
                [
                    { text: "No", onPress: () => console.log("Closing Modal") },
                    {
                        text: "Yes",
                        onPress: () =>
                            this.props.history.push("/accounts/edit"),
                    },
                ]
            );
            return false;
        }

        return true;
    }

    isVerifiedAccount() {
        return this.props.store.Account.isAccountsStripeVerified();
    }

    @action.bound
    validateInput = () => {
        const name = this.job.name.length > 1;
        const default_fee =
            Number(this.job.default_fee) >= process.env.REACT_APP_MINIMUM_FEE;

        if (!name) throw "Job Name is required. Please enter a Job Name.";
        if (!default_fee)
            throw (
                "Must have a fee of at least $" +
                process.env.REACT_APP_MINIMUM_FEE
            );
    };

    @action.bound
    handleSubmit = async () => {
        this.loading = true;

        try {
            this.validateInput();
        } catch (err) {
            Toast.fail(err, 3);
            this.loading = false;
            return;
        }

        const resError = await this.props.store.Job.createJob(this.job);
        this.loading = false;
        if (resError) {
            Toast.fail(resError, 1.5);
        } else {
            Toast.success("Job created", 1.5);
            this.props.history.push("/");
        }
    };

    componentDidMount() {
        this.user = this.props.store.User.getUserSession();
        var check = this.isMobileDevice();
    }

    render() {
        return (

            <div className="new-job-page">
                <div className="text-center">
                    <h2>Add Job</h2>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <InputItem
                        clear
                        placeholder="Job Name"
                        required
                        value={this.job.name}
                        onChange={(event) => this.handleChange("name", event)}
                    >
                        <img src="/assets/job.svg" alt="job" />
                    </InputItem>

                    <br />
                    {this.isMobileDevice() ? <div><DatePicker
                        mode="date"
                        title="Start Date"
                        required
                        value={this.job.start_date}
                        onChange={(event) =>
                            this.handleChange("start_date", event)
                        }
                    >
                        <List.Item arrow="horizontal">
                            <img src="/assets/clock1.svg" alt="clock" />
                            <span className="date-picker-label">
                                Start Date
                            </span>
                        </List.Item>
                    </DatePicker><br /></div> : <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="Start Date"
                            value={this.job.start_date}
                            onChange={(event) =>
                                this.handleChange("start_date", event)
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                    }
                    {this.isMobileDevice() ? <DatePicker
                        mode="date"
                        title="End Date"
                        required
                        value={this.job.end_date}
                        onChange={(event) =>
                            this.handleChange("end_date", event)
                        }
                    >
                        <List.Item arrow="horizontal">
                            <img src="/assets/clock2.svg" alt="clock" />
                            <span className="date-picker-label">
                                End Date
                            </span>
                        </List.Item>
                    </DatePicker> : <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="End Date"
                            value={this.job.end_date}
                            onChange={(event) =>
                                this.handleChange("end_date", event)
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                    }

                    <br />
                    {this.isMobileDevice() ? '' : <br/>}

                    <InputItem
                        clear
                        placeholder="Fee"
                        extra="dollar(s)"
                        type="number"
                        required
                        value={this.job.default_fee}
                        onChange={(event) =>
                            this.handleChange("default_fee", event)
                        }
                    >
                        <img src="/assets/dollar.svg" alt="dollar" />
                    </InputItem>

                    <br />
                    <List className="am-list-line">
                        <List.Item
                            className="am-list-item am-input-item am-list-item-middle"
                            extra={
                                <Switch
                                    checked={this.job.pre_signup}
                                    onChange={(event) =>
                                        this.handleChange("pre_signup", event)
                                    }
                                />
                            }
                        >
                            <>
                                <img src="/assets/lock.svg" alt="users" />
                                <span
                                    style={{
                                        color: "#a9a9a9",
                                        fontSize: "14px",
                                        marginLeft: "20px",
                                    }}
                                >
                                    Allow Pre Signup
                                </span>
                            </>
                        </List.Item>
                    </List>

                    <br />
                    <InputItem
                        clear
                        placeholder="Registrations"
                        extra="Max Pre Signup(s)"
                        type="number"
                        value={this.job.max_registration}
                        onChange={(event) =>
                            this.handleChange("max_registration", event)
                        }
                    >
                        <img src="/assets/user.svg" alt="users" />
                    </InputItem>

                    <br />
                    <TextareaItem
                        clear
                        placeholder="Notes"
                        rows={8}
                        value={this.job.description}
                        onChange={(event) =>
                            this.handleChange("description", event)
                        }
                    ></TextareaItem>
                </form>

                <div className="flex-center">
                    <Button
                        type="primary"
                        onClick={this.handleSubmit}
                        className="gf-button"
                    >
                        {this.loading ? <Icon type="loading" /> : "SAVE"}
                    </Button>
                </div>
            </div>
        );
    }
}

export default JobNew;
